<!-- <div class="section-wrapper" id="technology">
  <div class="container">
    <div class="title tech-title">
      <span class="text-wrapper">{{ 'COMPANY.TECHNOLOGY' | translate }}</span>
    </div>
  </div>
  <div class="image-wrapper">
    <div class="container">
      <div class="image">
        <app-anim-backbone></app-anim-backbone>
      </div>        
    </div>
  </div>
  <div class="container">
    <div class="content backbone">
      <img class="content-icon" loading="lazy" src="{{ baseUrl }}pictures/company_icon_backbone.svg" />
      <div class="content-title ct_1">
        <span class="text-wrapper">{{ 'COMPANY.FIBER_OPTIC_BACKBONE_MAP.TITLE' | translate }}</span>
      </div>
      <div class="description">
        {{ 'COMPANY.FIBER_OPTIC_BACKBONE_MAP.DESCRIPTION' | translate }}
      </div>
    </div>
  </div>

  <div class="image-wrapper">
    <div class="container">
      <div class="image">
        <app-anim-popcoverage></app-anim-popcoverage>
      </div>        
    </div>
  </div>
  <div class="container">
    <div class="content backbone">
      <img class="content-icon" loading="lazy" src="{{ baseUrl }}pictures/company_icon_pop.svg" />
      <div class="content-title ct_2">
        <span class="text-wrapper">{{ 'COMPANY.COVERAGE_POP.TITLE' | translate }}</span>
      </div>
      <div class="description smaller" innerHTML="{{ 'COMPANY.COVERAGE_POP.DESCRIPTION' | translate }}">
      </div>
    </div>
  </div>

  <div class="container">
    <div class="dwdm">
      <div class="content">
        <img class="content-icon" loading="lazy" src="{{ baseUrl }}pictures/company_icon_dwdm.svg" />
        <div class="content-title ct_3">
          <span class="text-wrapper">{{ 'COMPANY.DWDM_TECHNOLOGY.TITLE' | translate }}</span>
        </div>
        <div class="description smaller" innerHTML="{{ 'COMPANY.DWDM_TECHNOLOGY.DESCRIPTION' | translate }}">
        </div>
      </div>
      <div class="image">
        <app-anim-dwdm></app-anim-dwdm>
      </div>
    </div>      
  </div>
</div> -->

<div class="section-wrapper" id="company_profile">
  <div class="container">
    <h2 class="title">{{ "COMPANY.CREDENTIALS.TITLE" | translate }}</h2>
    <a
      class="credentials-content"
      href="assets/docs/Weave-Profile-business_plan_280524_rev.pdf"
      target="_blank"
    >
      <!-- <img
        loading="lazy"
        src="{{ baseUrl }}pictures/company_icon_credentials.svg"
      /> -->
      {{ "COMPANY.CREDENTIALS.CORPORATE_CREDENTIALS" | translate }}
    </a>
  </div>
</div>

<div class="section-wrapper" id="company_prospectus">
  <div class="container">
    <h2 class="title">{{ "COMPANY.PROSPECTUS.ANNOUNCEMENT" | translate }}</h2>
    <h3 class="subtitle">
      {{ "COMPANY.PROSPECTUS.DISCLOSURE_OF_INFORMATION" | translate }}
    </h3>
    <div class="d-flex flex-wrap gap-3" style="margin-bottom: 30px">
      <a
        class="credentials-content"
        href="assets/docs/07_11_2024-Laporan_Informasi_Transaksi_Afiliasi.pdf"
        target="_blank"
      >
        Laporan Informasi Transaksi Afiliasi
      </a>
      <a
        class="credentials-content"
        href="assets/docs/07_11_2024-Laporan_Informasi_atau_Fakta_Material.pdf"
        target="_blank"
      >
        Laporan Informasi atau Fakta Material
      </a>
      <a
        class="credentials-content"
        href="assets/docs/Pengunduran Diri Bpk Gilman P.N-PT IJE.pdf"
        target="_blank"
      >
        Pengunduran Diri Direksi
      </a>
      <a class="credentials-content" href="assets/docs/KI-EDC-(IJEE).pdf" target="_blank">
        Keterbukaan Informasi atas Fasilitas Pembiayaan dari EDC
      </a>
    </div>

    <h3 class="subtitle">{{ "COMPANY.PROSPECTUS.PROSPECTUS" | translate }}</h3>
    <div class="d-flex flex-wrap gap-3">
      <a
        class="credentials-content"
        href="assets/docs/240522_Prospektus Ringkas_IJE.pdf"
        target="_blank"
      >
        {{ "COMPANY.PROSPECTUS.SHORT_PROSPECTUS" | translate }}
      </a>

      <a
        class="credentials-content"
        href="assets/docs/240528_Prospektus_IJE.pdf"
        target="_blank"
      >
        {{ "COMPANY.PROSPECTUS.PROSPECTUS" | translate }}
      </a>

      <a
        class="credentials-content"
        href="assets/docs/IJE-Prospektus_Akhir_Rev_Reg_III_25062024.pdf"
        target="_blank"
      >
        {{ "COMPANY.PROSPECTUS.FINAL_PROSPECTUS" | translate }}
      </a>
    </div>
  </div>
</div>
